import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/base/alert-dialog'
import { Icon } from '@/components/common/icons/Icon'
import { useUiStore, useUiStoreActions } from '@/stores/ui'

const ErrorDialog = () => {
  const rootElementRef =
    useUiStore(state => state.rootElementRef) ?? document.body // the default fallback is document.body

  const displayErrorDialog = useUiStore(state => state.displayErrorDialog)
  const errorCancelLabel = useUiStore(state => state.errorCancelLabel)
  const errorConfirmLabel = useUiStore(state => state.errorConfirmLabel)
  const errorTitle = useUiStore(state => state.errorTitle)
  const errorDescription = useUiStore(state => state.errorDescription)
  const errorOnClose = useUiStore(state => state.errorOnClose)
  const errorOnConfirm = useUiStore(state => state.errorOnConfirm)
  const { hideErrorDialog, setErrorDialogRef, showErrorDialog } =
    useUiStoreActions()

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      hideErrorDialog()
    } else {
      showErrorDialog()
    }
  }

  return (
    <AlertDialog open={displayErrorDialog} onOpenChange={handleOpenChange}>
      <AlertDialogContent
        className="z-60"
        container={rootElementRef}
        ref={setErrorDialogRef}
      >
        <AlertDialogHeader>
          <div className="flex flex-col items-center justify-center gap-y-8">
            <Icon className="h-[52px] w-[52px] fill-muted" tag="warning" />
            <AlertDialogTitle>{errorTitle}</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="px-4">
            {errorDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={errorOnConfirm}>
            {errorConfirmLabel}
          </AlertDialogAction>
          {errorCancelLabel ? (
            <AlertDialogCancel onClick={errorOnClose}>Cancel</AlertDialogCancel>
          ) : null}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
ErrorDialog.displayName = 'ErrorDialog'

export { ErrorDialog }
